import { render, staticRenderFns } from "./DiscountDialog.vue?vue&type=template&id=5ef1aa78&"
import script from "./DiscountDialog.vue?vue&type=script&lang=js&"
export * from "./DiscountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports